import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons/faWarehouse';
import type { IconProps } from '../../types';

export function WarehouseIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Warehouse',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faWarehouse}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
